import ChevronIcon from "../../../../../../../../assets/svg/chevron-icon";
import { KnowledgeBaseCategory } from "../../utils/types";

const CategoryCard = ({
  topic,
  onClick,
}: {
  topic: KnowledgeBaseCategory;
  onClick?: (topic: KnowledgeBaseCategory) => void;
}) => {
  const renderIcon = () => {
    if (typeof topic?.icon === "string") {
      return <img src={topic?.icon} alt={topic?.title} className={topic?.iconClassName} />;
    }
    const IconComponent = topic?.icon;
    return <IconComponent className={topic?.iconClassName} />;
  };

  return (
    <div
      className="flex flex-col items-center gap-3 w-[220px] pt-4 pb-3 px-[18px] rounded-lg border border-border-gray dark:border-border-gray-dk hover:bg-hover-effect dark:hover:bg-hover-effect-dk transition-shadow cursor-pointer"
      onClick={() => onClick?.(topic)}
    >
      {renderIcon()}

      <div className="flex flex-col items-center gap-1 w-full">
        <p className="text-base font-medium text-heading-text dark:text-heading-text-dk leading-none whitespace-nowrap">
          {topic?.title}
        </p>
        <p className="text-sm font-normal text-dark-gray dark:text-dark-gray-dk leading-normal text-center w-full">
          {topic?.description}
        </p>
      </div>

      <div className="flex items-center justify-center gap-0 w-full">
        <p className="text-sm font-medium text-verba-blue dark:text-verba-blue-dk leading-normal whitespace-nowrap">
          See all {topic?.articleCount} articles
        </p>
        <ChevronIcon className="w-4 h-4 text-verba-blue dark:text-verba-blue-dk -rotate-90" />
      </div>
    </div>
  );
};

export default CategoryCard;
